import React, {Component} from 'react';
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';
import {slugify} from '../../helpers/general.helper';
import {addEventToFavorite, removeEventFromFavorite} from '../../actions/festival.actions';
import { LOGIN_ROUTE } from '../../config/routes';
import {withRouter} from 'react-router';

class FestivalResults extends Component {
    
    removeFromFavorite = (uuid, eventId) => {
        if (localStorage.getItem('login_type') === 'authenticated'){
            const payload = {
                favorite: uuid,
                event_id: eventId
            }

            this.props.removeEventFromFavorite(payload);
        } else {
            this.props.history.push(LOGIN_ROUTE);
        }
    }

    addToFavorite = (uuid) => {
        if (localStorage.getItem('login_type') === 'authenticated'){
            this.props.addEventToFavorite(uuid);
        } else {
            this.props.history.push(LOGIN_ROUTE);
        }
    }

    getFavoriteEvents = (item) => {
        return item.favorite.length !== 0 ?
            <span className="add-fav-active" onClick={() => this.removeFromFavorite(item.favorite[0].uuid, item.event_id)} /> :
            <span className="add-fav" onClick={() => this.addToFavorite(item.event_uuid)} />
    }

    getEvents = () => {
        if(this.props.events){
            if (this.props.events.length > 0) {
                return this.props.events.map((item, i) => { 
                    return <div className="table-row clearfix" key={i}>
                        <div className="table-column clearfix favs text-center">
                            {this.getFavoriteEvents(item)}
                        </div>
                        <div className="table-column title-hours">
                            <div className="item-hours clearfix float-left">
                                {/* <span className="radius-item"></span> */}
                                <span className="hour-item">{item.event_time}</span>
                            </div>
                            <div className="second-column-details">
                                <span className="blue-text db">{item.event_type}</span>
                                <Link to={`/eveniment/${item.event_id}/${slugify(item.event_title)}`} className="white-text">
                                    <span className="white-text db">{item.event_title}</span>
                                </Link>
                            </div>
                        </div>

                        <div className="table-column location">
                            <span className="pinpoint" />
                            <div className="location-details-txt">
                                <span className="white-text db">{item.event_location_name}</span>
                                <span className="grey-text db">{item.event_location_address}, {item.event_location_locality}</span>
                            </div>
                        </div>

                        {/* <div className="table-column interact">
                            <span className="ticket" />
                            <div className="interact-details-txt">
                                <span className="white-text db">Cumpara bilet acum</span>
                                <span className="grey-text db">Pret bilet: 20 LEI</span>
                            </div>
                        </div> */}
                    </div>
                })
            } else {
                return <p className="text-center text-white">Nu exista rezultate</p>
            }
        }
    }
    render() {
        return (
            <div className="festival-table clearfix">
               {this.getEvents()}
            </div>
        );
    }
}

const mapStateToProps = state => ({
});
export default withRouter(connect(mapStateToProps, {addEventToFavorite, removeEventFromFavorite})(FestivalResults));





// WEBPACK FOOTER //
// ./src/SHARED/components/festivalresults/festivalresults.component.js